import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import submit from './submit';

class SearchFormWrapper extends Component {
  onSubmit = e => {
    console.log('Submitting From Form', e);
    e.preventDefault();
    let { handleSubmit } = this.props;
    setTimeout(handleSubmit(submit));
  };
  render() {
    let { children } = this.props;
    return <form onSubmit={this.onSubmit}>{children}</form>;
  }
}

SearchFormWrapper = reduxForm({
  form: 'SearchForm',
  onSubmit: submit,
  destroyOnUnmount: false
})(SearchFormWrapper);

export default connect(
  null,
  { change }
)(SearchFormWrapper);



// WEBPACK FOOTER //
// ./src/components/SearchListing/SearchForm/SearchFormWrapper.js